export default "__VITE_ASSET__BlXQTQBK__"